import type { PrivateAsset } from '@nest-react/domain';

export type AssetUploadStatus =
  'queued' | 'preparing' | 'uploading' | 'complete' | 'failed';

export type AssetUploadItem = {
  id: string;
  file: File;
  mediaType: PrivateAsset['type'];
  status: AssetUploadStatus;
  progress: number;
  error?: string;
};

type NewUploadItem = Pick<AssetUploadItem, 'file' | 'mediaType'>;

export const createUploadItems = (items: NewUploadItem[]): AssetUploadItem[] =>
  items.map(item => ({
    ...item,
    id: crypto.randomUUID(),
    status: 'queued',
    progress: 0,
  }));

export const updateUploadItem = (
  items: AssetUploadItem[],
  id: string,
  changes: Partial<Omit<AssetUploadItem, 'id' | 'file' | 'mediaType'>>
): AssetUploadItem[] =>
  items.map(item => (item.id === id ? { ...item, ...changes } : item));

export const removeUploadItem = (
  items: AssetUploadItem[],
  id: string
): AssetUploadItem[] => items.filter(item => item.id !== id);
